import { useState, useEffect, useCallback } from 'react';
import { Bold, Flex } from './TremorCompat';
import { InputNumber, Panel, Text } from 'rsuite';

import { DisplayIcon } from './DisplayIcon';
import { devLog } from '../utils/devLog';

export const DisplayStepperItem = ({ register, tc, icon, min, max, step, onChange, borderOff }) => {
  const toStepperValue = useCallback(
    (registerValue) => (Number.isFinite(registerValue) ? registerValue * step : min),
    [step, min],
  );

  const [value, setValue] = useState(() => toStepperValue(register.value));

  const updateValue = (value, event) => {
    devLog(event, value);
    onChange(register, value / step);
  };

  useEffect(() => {
    setValue(toStepperValue(register.value));
  }, [register.value, toStepperValue]);

  return (
    <Panel bordered={!borderOff} style={{ backgroundColor: 'white' }}>
      <Flex justifyContent="start" className="space-x-2">
        <DisplayIcon icon={icon} />
        <div className="truncate">
          <Text color={tc} className="truncate">
            {register.title}
          </Text>
          <Text color={tc} className="truncate">
            <Bold>{register.display}</Bold>
          </Text>
        </div>
        <div
          style={{
            display: 'block',
            width: '100%',
          }}
        >
          <InputNumber
            min={min}
            max={max}
            step={step}
            scrollable={false}
            postfix={register.unit}
            value={value}
            onChange={updateValue}
          />
        </div>
      </Flex>
    </Panel>
  );
};
